module.exports = __webpack_public_path__ + "static/media/BANANA-SFP-BNB.8e88e229.svg";